import React from "react"
import {
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardBody,
} from "reactstrap"
import { Dropdown, Form } from "react-bootstrap"

import BackButton from "./BackButton"
import { useTranslation } from "react-i18next"
import useAllowExports from "hooks/useAllowExports"

const DataExportDropdown = ({
  onDownloadPDF,
  onDownloadCSV,
  onDownloadExcel,
  // onReset,
  cardTitle,
  isAddBtn,
  isEditBtn,
  addBtnText,
  editBtnText,
  onAddBtnClick,
  onEditBtnClick,
  isExportData,
  isSearchBtn,
  handleSearchClick,
  isCustomColumn,
  showDropdown,
  columns,
  selectedColumns,
  handleColumnSelect,
  handleDropdownToggle,
  dropdownRef,
  isXLSX = true,
  isCustomPage = false,
  perPageOptions = [],
  itemsPerPage,
  handlePerPageChange = () => {},
  exportOptions,
  hideCSV = false,
}) => {
  const { t } = useTranslation()
  const allowExports = useAllowExports()
  const showExportActions = Boolean(isExportData) && allowExports

  return (
    <CardBody className="border-bottom">
      <div className="d-flex align-items-center" style={{ minHeight: 36 }}>
        {/* <BackButton /> */}
        <h5 className="mb-0 card-title flex-grow-1">{cardTitle}</h5>
        <div className="d-flex flex-shrink-0">
          {isCustomPage && (
            <select
              className="form-select me-2"
              value={itemsPerPage}
              onChange={handlePerPageChange}
            >
              {perPageOptions?.map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          )}
          {isCustomColumn && (
            <>
              <Button
                style={{ width: 40, height: 36, padding: 0, border: "none" }}
                className={`bg-success position-relative  me-1`}
                onClick={handleDropdownToggle}
              >
                <div
                  className="circle g_center"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    background: "white",
                    borderRadius: "50%",
                    width: 22,
                    height: 22,
                  }}
                >
                  <i
                    className="bx bx-plus text-black"
                    style={{ fontSize: 18 }}
                  ></i>
                </div>
              </Button>
              <div ref={dropdownRef}>
                <Dropdown show={showDropdown}>
                  <Dropdown.Menu>
                    {columns.map(column => (
                      <div className="dropdown-item " key={column.value}>
                        <Form.Check
                          type="checkbox"
                          label={column.name}
                          disabled={column.readOnly}
                          checked={
                            column.value === "selectAll"
                              ? selectedColumns.length === columns.length - 1
                              : selectedColumns.includes(column.value)
                          }
                          onClick={e => handleColumnSelect(e, column.value)}
                        />
                      </div>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </>
          )}
          {isAddBtn && (
            <Button
              color="success"
              style={{ whiteSpace: "nowrap" }}
              onClick={onAddBtnClick}
              className="me-1"
            >
              {addBtnText}
            </Button>
          )}
          {isEditBtn && (
            <Button color="success" onClick={onEditBtnClick} className="me-1">
              {editBtnText}
            </Button>
          )}

          {/* <Button
            style={{ minWidth: 40, height: 36, padding: 0 }}
            className={`btn btn-light ${isExportData && "me-1"}`}
            onClick={onReset}
          >
            <i className="mdi mdi-refresh" style={{ fontSize: 18 }}></i>
          </Button> */}
          {/* {isSearchBtn && (
            <Button
              color="success"
              onClick={handleSearchClick}
              style={{ width: 40, height: 36 }}
              className="mx-1"
            >
              <i className="bx bx-search-alt-2" style={{ fontSize: 20 }}></i>
            </Button>
          )} */}
          {showExportActions && (
            <UncontrolledDropdown className="dropdown d-inline-block me-1">
              <DropdownToggle
                type="menu"
                className="btn btn-success"
                id="dropdownMenuButton1"
              >
                <i className="mdi mdi-dots-vertical"></i>
              </DropdownToggle>
              <DropdownMenu>
                {exportOptions && exportOptions.length > 0 ? (
                  exportOptions.map((opt, idx) => (
                    <li key={idx}>
                      <DropdownItem href="#">
                        <button
                          className="transparent_btn"
                          onClick={opt.onClick}
                        >
                          {t(opt.labelKey)}
                        </button>
                      </DropdownItem>
                    </li>
                  ))
                ) : (
                  <>
                    {!hideCSV && (
                      <li>
                        <DropdownItem href="#">
                          <button
                            className="transparent_btn"
                            onClick={onDownloadCSV}
                          >
                            {t("Download CSV")}
                          </button>
                        </DropdownItem>
                      </li>
                    )}
                    {isXLSX && (
                      <li>
                        <DropdownItem href="#">
                          <button
                            className="transparent_btn"
                            onClick={onDownloadExcel}
                          >
                            {t("Download XLSX")}
                          </button>
                        </DropdownItem>
                      </li>
                    )}
                  </>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          )}
        </div>
      </div>
    </CardBody>
  )
}

export default DataExportDropdown
